import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { directionOf } from '@/i18n';

/**
 * Direction is applied in exactly one place: the <html> element.
 * Everything else inherits it, so no component ever sets `direction` itself.
 */
export function useDirection(): 'rtl' | 'ltr' {
  const { i18n } = useTranslation();
  const direction = directionOf(i18n.language);

  useEffect(() => {
    document.documentElement.setAttribute('dir', direction);
    document.documentElement.setAttribute('lang', i18n.language);
  }, [direction, i18n.language]);

  return direction;
}
